import React, { useCallback } from 'react';

import * as S from './styles';

type Tab = {
  active: boolean;
  id: string;
  title: string;
  to: string;
};

type TabProps = {
  active: boolean;
  id: string;
  onClick?: (tab: string) => void;
  title: string;
  to: string;
};

type OwnProps = {
  className?: string;
  onClick?: (tab: string) => void;
  tabs: Tab[];
};

const Tab = ({ active, id, onClick, title, to }: TabProps) => {
  const handleOnClick = useCallback(() => {
    if (!onClick) return null;
    return onClick(id);
  }, [id, onClick]);

  return (
    <S.TabLink active={active} onClick={handleOnClick} to={to}>
      {title}
    </S.TabLink>
  );
};

const Tabs = ({ className, onClick, tabs }: OwnProps) => {
  return (
    <S.Tabs className={className}>
      {tabs.map(tab => (
        <Tab {...tab} key={tab.id} onClick={onClick} />
      ))}
    </S.Tabs>
  );
};

export default Tabs;
